export default "__VITE_ASSET__BWWMLSLj__"